import { post } from '../../utils/fetch';

export const reauthoriseJira = async (
  organizationId: string | number,
  integrationId: string | number
) => {
  const result = await post(
    `/organizations/${organizationId}/integrations/${integrationId}/reauthorise_jira`,
    {}
  );
  submitJiraAuthorisation(result.auth_path);
};

export const connectJiraProject = async (
  organizationId: string | number,
  projectId: string | number
) => {
  const result = await post(
    `/organizations/${organizationId}/integrations/connect_jira_project`,
    { project_id: projectId }
  );
  if (result.auth_path) {
    submitJiraAuthorisation(result.auth_path);
  } else {
    window.location.href = result.redirect_path;
  }
};

const submitJiraAuthorisation = (authPath: string) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = authPath;
  const csrf = document.createElement('input');
  csrf.type = 'hidden';
  csrf.name = 'authenticity_token';
  csrf.value =
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content || '';
  form.appendChild(csrf);
  document.body.appendChild(form);
  form.submit();
};
